export const api=process.env.NODE_ENV === 'production' ? "https://admin.xynes.com/api/" : "http://localhost:5001/admin";
export const imagesDir= process.env.NODE_ENV === 'production' ? "https://xynes.com/api/public/images/" : "http://localhost:5001/public/images/";
